import React from "react";
import { Avatar } from "@mui/material";
import DarkOSPng from "../../static/img/products/DarkOS.png";

export default function DarkOS({variant, alt, sx}) {
    return <Avatar variant={variant} src={DarkOSPng} alt={alt} sx={sx} />;
}
